import CustomInnerAutocomplete from "./customInnerAutocomplete";
import RenderOption from "./renderOption";

export default function Option({
  index,
  value,
  option,
  onSelect,
  innerOpen,
  setInnerOpen,
  active,
  innerListRef,
  innerActive,
  setInnerActive,
  innerOptions,
  setActive,
  inputFieldRef,
  dataIdx,
}) {
  if (option.innerOptions !== undefined) {
    return (
      <CustomInnerAutocomplete
        active={active}
        value={value}
        onSelect={onSelect}
        outerOption={option}
        innerOpen={innerOpen}
        setInnerOpen={setInnerOpen}
        innerListRef={innerListRef}
        innerActive={innerActive}
        setInnerActive={setInnerActive}
        innerOptions={innerOptions}
        setActive={setActive}
        index={index}
        inputFieldRef={inputFieldRef}
        dataIdx={dataIdx}
      ></CustomInnerAutocomplete>
    );
  }
  return (
    <RenderOption
      key={index}
      option={option}
      onSelect={onSelect}
      value={value}
      active={active}
      setActive={setActive}
      index={index}
      inputFieldRef={inputFieldRef}
      dataIdx={dataIdx}
    ></RenderOption>
  );
}
